import React from "react";
import Pill from "../common/Pill";
export default function WhyItMatters() {
  return (
    <div className="py-10">
      <div className="max-w-6xl px-4 mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="flex justify-center mb-6">
            <Pill text="INSTANT HELP" backgroundColor="#F3E6E6" />
          </div>
          <h2
            className="text-2xl sm:text-3xl md:text-5xl font-bold text-gray-900 mb-5 tracking-tight"
            style={{ color: "#2d1810" }}
          >
            Why It Matters
          </h2>
          <p className="text-gray-600">
            Help your customers immediately while reducing staff workload.
          </p>
        </div>

        {/* Content Flex Layout */}
        <div className="flex flex-col  md:flex-row justify-center gap-4">
          {/* Left Large Card */}
          <div className="flex justify-between flex-col bg-gray-100 rounded-3xl p-8 w-full md:w-1/2">
            <p
              className="text-gray-700 text-lg leading-relaxed mb-16 pr-8"
              style={{ color: "#4a4a4a" }}
            >
              Customers expect instant answers, but staff can't be everywhere at
              once. Our platform ensures every visitor gets help the moment they
              need it.
            </p>

            <div className="flex items-center justify-center gap-4">
              <div className="w-full md:w-1/2 pl-3 border-l border-gray-400">
                <div className="text-4xl font-semibold text-gray-600 mb-3">
                  90%
                </div>
                <div className="flex items-center gap-2 text-gray-600">
                  <svg
                    className="w-5 h-5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
                  </svg>
                  <span className="text-base font-normal">Faster response</span>
                </div>
              </div>
              <div className="w-full md:w-1/2 pl-3 border-l border-gray-400">
                <div className="text-4xl font-semibold text-gray-600 mb-3">
                  75%
                </div>
                <div className="flex items-center gap-2 text-gray-600">
                  <svg
                    className="w-5 h-5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                  <span className="text-base font-normal">
                    Fewer repetitive queries
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Benefits Grid */}
          <div className="grid md:grid-cols-3 gap-4 w-full md:w-1/2 p-4  bg-orange-50  rounded-3xl">
            {/* Cut Repetitive Questions - Spans 2 columns */}
            <div className="md:col-span-2 rounded-3xl p-6 flex flex-col bg-white">
              <div className="w-14 h-14  flex items-center justify-center mb-4 ">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="35"
                    height="35"
                    rx="17.5"
                    stroke="url(#paint0_linear_757_976)"
                  />
                  <path
                    d="M22.0229 15.3479H27.0149L23.8339 12.1649C22.8098 11.1408 21.5341 10.4043 20.1351 10.0295C18.7361 9.65476 17.2631 9.65487 15.8642 10.0299C14.4652 10.4049 13.1896 11.1415 12.1657 12.1658C11.1417 13.1901 10.4054 14.4659 10.0309 15.8649M8.98489 25.6439V20.6519M8.98489 20.6519H13.9769M8.98489 20.6519L12.1649 23.8349C13.189 24.8591 14.4647 25.5955 15.8637 25.9703C17.2627 26.3451 18.7357 26.345 20.1346 25.97C21.5336 25.595 22.8091 24.8584 23.8331 23.8341C24.8571 22.8098 25.5933 21.534 25.9679 20.1349M27.0149 10.3559V15.3459"
                    stroke="url(#paint1_linear_757_976)"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_757_976"
                      x1="17.9139"
                      y1="44.2437"
                      x2="17.9139"
                      y2="6.20168"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#8B0000" stop-opacity="0.376471" />
                      <stop offset="0.5" stop-color="#B22222" />
                      <stop offset="1" stop-color="#FF4D4D" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_757_976"
                      x1="17.9563"
                      y1="30.0303"
                      x2="17.9563"
                      y2="12.5915"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#8B0000" stop-opacity="0.376471" />
                      <stop offset="0.5" stop-color="#B22222" />
                      <stop offset="1" stop-color="#FF4D4D" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <h3 className="text-gray-700 font-medium leading-relaxed">
                Cut Repetitive
                <br />
                Questions
              </h3>
            </div>

            {/* Boost Customer Satisfaction - Spans 1 column */}
            <div className="md:col-span-1 rounded-3xl p-6 flex flex-col bg-white">
              <div className="w-14 h-14  flex items-center justify-center mb-4">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="35"
                    height="35"
                    rx="17.5"
                    stroke="url(#paint0_linear_757_978)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18 8.25C12.615 8.25 8.25 12.615 8.25 18C8.25 23.385 12.615 27.75 18 27.75C23.385 27.75 27.75 23.385 27.75 18C27.75 12.615 23.385 8.25 18 8.25ZM15.375 14.25C14.835 14.25 14.547 14.669 14.439 14.884C14.3107 15.1544 14.246 15.4507 14.25 15.75C14.25 16.048 14.309 16.355 14.439 16.616C14.547 16.831 14.834 17.25 15.375 17.25C15.915 17.25 16.203 16.831 16.311 16.616C16.441 16.356 16.5 16.048 16.5 15.75C16.5 15.452 16.441 15.145 16.311 14.884C16.203 14.669 15.916 14.25 15.375 14.25ZM19.689 14.884C19.797 14.669 20.084 14.25 20.625 14.25C21.165 14.25 21.453 14.669 21.561 14.884C21.691 15.144 21.75 15.452 21.75 15.75C21.75 16.048 21.691 16.355 21.561 16.616C21.453 16.831 21.166 17.25 20.625 17.25C20.085 17.25 19.797 16.831 19.689 16.616C19.5607 16.3456 19.496 16.0493 19.5 15.75C19.5 15.452 19.559 15.145 19.689 14.884ZM21.712 21.712C21.7857 21.6433 21.8448 21.5605 21.8858 21.4685C21.9268 21.3765 21.9488 21.2772 21.9506 21.1765C21.9524 21.0758 21.9338 20.9758 21.8961 20.8824C21.8584 20.789 21.8023 20.7042 21.731 20.633C21.6598 20.5617 21.575 20.5056 21.4816 20.4679C21.3882 20.4302 21.2882 20.4116 21.1875 20.4134C21.0868 20.4152 20.9875 20.4372 20.8955 20.4782C20.8035 20.5192 20.7207 20.5783 20.652 20.652C20.3038 21.0003 19.8903 21.2766 19.4353 21.4652C18.9803 21.6537 18.4925 21.7507 18 21.7507C17.5075 21.7507 17.0197 21.6537 16.5647 21.4652C16.1097 21.2766 15.6962 21.0003 15.348 20.652C15.2058 20.5195 15.0178 20.4474 14.8235 20.4508C14.6292 20.4543 14.4438 20.533 14.3064 20.6704C14.169 20.8078 14.0903 20.9932 14.0868 21.1875C14.0834 21.3818 14.1555 21.5698 14.288 21.712C15.2725 22.6964 16.6078 23.2494 18 23.2494C19.3922 23.2494 20.7275 22.6964 21.712 21.712Z"
                    fill="url(#paint1_linear_757_978)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_757_978"
                      x1="17.9139"
                      y1="44.2437"
                      x2="17.9139"
                      y2="6.20168"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#8B0000" stop-opacity="0.376471" />
                      <stop offset="0.5" stop-color="#B22222" />
                      <stop offset="1" stop-color="#FF4D4D" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_757_978"
                      x1="17.9533"
                      y1="32.2153"
                      x2="17.9533"
                      y2="11.6092"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#8B0000" stop-opacity="0.376471" />
                      <stop offset="0.5" stop-color="#B22222" />
                      <stop offset="1" stop-color="#FF4D4D" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <h3 className="text-gray-700 font-medium  leading-relaxed">
                Boost Customer
                <br />
                Satisfaction
              </h3>
            </div>

            {/* Offer 24/7 Assistance - Spans 1 column */}
            <div className="md:col-span-1 rounded-3xl p-6 flex flex-col bg-white">
              <div className="w-14 h-14 flex items-center justify-center mb-4">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="35"
                    height="35"
                    rx="17.5"
                    stroke="url(#paint0_linear_757_983)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18 8.25C12.615 8.25 8.25 12.615 8.25 18C8.25 23.385 12.615 27.75 18 27.75C23.385 27.75 27.75 23.385 27.75 18C27.75 12.615 23.385 8.25 18 8.25ZM18.75 12C18.75 11.8011 18.671 11.6103 18.5303 11.4697C18.3897 11.329 18.1989 11.25 18 11.25C17.8011 11.25 17.6103 11.329 17.4697 11.4697C17.329 11.6103 17.25 11.8011 17.25 12V18C17.25 18.414 17.586 18.75 18 18.75H22.5C22.6989 18.75 22.8897 18.671 23.0303 18.5303C23.171 18.3897 23.25 18.1989 23.25 18C23.25 17.8011 23.171 17.6103 23.0303 17.4697C22.8897 17.329 22.6989 17.25 22.5 17.25H18.75V12Z"
                    fill="url(#paint1_linear_757_983)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_757_983"
                      x1="17.9139"
                      y1="44.2437"
                      x2="17.9139"
                      y2="6.20168"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#8B0000" stop-opacity="0.376471" />
                      <stop offset="0.5" stop-color="#B22222" />
                      <stop offset="1" stop-color="#FF4D4D" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_757_983"
                      x1="17.9533"
                      y1="32.2153"
                      x2="17.9533"
                      y2="11.6092"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#8B0000" stop-opacity="0.376471" />
                      <stop offset="0.5" stop-color="#B22222" />
                      <stop offset="1" stop-color="#FF4D4D" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <h3 className="text-gray-700 font-medium text-sm leading-relaxed">
                Offer 24/7
                <br />
                Assistance
              </h3>
            </div>

            {/* Stay Consistent Everywhere - Spans 2 columns */}
            <div className="md:col-span-2 rounded-3xl p-6 flex flex-col bg-white">
              <div className="w-14 h-14 flex items-center justify-center mb-4">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="35"
                    height="35"
                    rx="17.5"
                    stroke="url(#paint0_linear_757_988)"
                  />
                  <path
                    d="M27.7212 18.7519C27.8568 17.0298 27.5305 15.3028 26.7762 13.7489C25.5275 14.9353 24.0515 15.8565 22.4372 16.4569C22.567 18.0502 22.4951 19.6536 22.2232 21.2289C24.1877 20.7341 26.049 19.8955 27.7212 18.7519ZM20.6342 21.5499C20.9536 20.0229 21.0653 18.4598 20.9662 16.9029C20.0142 17.1299 19.0212 17.2499 18.0002 17.2499C16.9792 17.2499 15.9862 17.1299 15.0342 16.9029C14.9374 18.4598 15.0491 20.0226 15.3662 21.5499C17.112 21.8175 18.8884 21.8175 20.6342 21.5499ZM15.7722 23.1189C17.2524 23.294 18.748 23.294 20.2282 23.1189C19.7195 24.7565 18.9685 26.3087 18.0002 27.7239C17.0319 26.3087 16.2809 24.7565 15.7722 23.1189ZM13.7772 21.2299C13.5038 19.654 13.4319 18.0499 13.5632 16.4559C11.9485 15.8556 10.4721 14.9344 9.22319 13.7479C8.469 15.3022 8.14313 17.0296 8.27919 18.7519C9.95133 19.8955 11.8127 20.7351 13.7772 21.2299ZM27.3562 20.7519C26.8513 22.4628 25.8874 24.0028 24.5691 25.2045C23.2507 26.4063 21.6284 27.224 19.8782 27.5689C20.7547 26.0951 21.4237 24.5075 21.8662 22.8509C23.7957 22.4465 25.6487 21.7383 27.3562 20.7529V20.7519ZM8.64419 20.7519C10.3262 21.7229 12.1742 22.4399 14.1342 22.8509C14.5767 24.5075 15.2457 26.0951 16.1222 27.5689C14.3721 27.2241 12.7498 26.4066 11.4315 25.205C10.1132 24.0034 9.14924 22.4636 8.64419 20.7529V20.7519ZM19.8782 8.42988C22.3559 8.91689 24.5483 10.3457 25.9942 12.4159C24.9269 13.4943 23.6527 14.346 22.2482 14.9199C21.8698 12.6277 21.0659 10.4265 19.8782 8.42988ZM18.0002 8.27588C19.4596 10.408 20.4185 12.8422 20.8052 15.3969C19.9082 15.6269 18.9682 15.7499 18.0002 15.7499C17.0322 15.7499 16.0922 15.6279 15.1952 15.3969C15.5819 12.8422 16.5407 10.408 18.0002 8.27588ZM16.1222 8.42988C14.9344 10.4265 14.1306 12.6277 13.7522 14.9199C12.3476 14.346 11.0735 13.4943 10.0062 12.4159C11.4522 10.346 13.6446 8.91654 16.1222 8.42988Z"
                    fill="url(#paint1_linear_757_988)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_757_988"
                      x1="17.9139"
                      y1="44.2437"
                      x2="17.9139"
                      y2="6.20168"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#8B0000" stop-opacity="0.376471" />
                      <stop offset="0.5" stop-color="#B22222" />
                      <stop offset="1" stop-color="#FF4D4D" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_757_988"
                      x1="17.9534"
                      y1="32.1773"
                      x2="17.9534"
                      y2="11.6262"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#8B0000" stop-opacity="0.376471" />
                      <stop offset="0.5" stop-color="#B22222" />
                      <stop offset="1" stop-color="#FF4D4D" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <h3 className="text-gray-700 font-medium leading-relaxed">
                Stay Consistent
                <br />
                Everywhere
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
